import {
  Component, OnInit, Input, Output, EventEmitter, QueryList, ViewContainerRef, ViewChild,
  ComponentFactoryResolver, Injector, OnDestroy
} from '@angular/core';
import { ConfigBaseComponent } from '../../../models/config-base-component';
import { FormGroup, FormControl, NgForm, Validators } from '@angular/forms';
import { StaticData } from '../../../helpers/static-data';
import { Subject } from 'rxjs';
import { DataTableComponent } from '../data-table/data-table.component';
import { ComponentsContainer } from 'src/app/models/components-container';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { Utilities } from 'src/app/helpers/utilities';
import { List } from '../../../../assets/linqts/compilado/index';
import { HelperImages } from 'src/app/helpers/helper-images';
import { ChangeDetectorRef } from '@angular/core';

// FABRIC VARIABLE (necesaria para inicializar elementos de FABRIC UI en typeScript)
declare var fabric: any;

@Component({
  selector: 'app-dynamic-controls',
  templateUrl: './dynamic-controls.component.html',
  styleUrls: ['./dynamic-controls.component.scss']
})

export class DynamicControlsComponent extends ConfigBaseComponent implements OnInit, OnDestroy {

  @ViewChild('DynamicComponentViewer', { read: ViewContainerRef, static: false }) DynamicComponentViewer: ViewContainerRef;

  @Input() comboxConfigs: any = {};
  @Input() public parentCallRefresh: Subject<any>;
  @Input() public parentClearCall: Subject<any>;
  @Input() componentsContainer: ComponentsContainer;
  @Input() hideDataTable: boolean = false;
  @Input() isModelContainer: boolean = false;
  @Input() modeloClone: any = null;
  @Input() configPermisos: any = null;
  @Output() onActionEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataTableEditEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSetConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectionEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloneEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoadGridEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectedComboBoxEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() botonProcesando: string;
  @Input() textoBotonProcesando: string;
  @Input() textoBoton: string;
  @Output() onGuardarForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLimpiarConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() onModalFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onImportarForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() isReactive: boolean = true;
  @Output() public parentContext: any;

  public name: string;

  public showSidePanel: boolean = false;
  public sidePanelKey: string = ''; // Clave única para forzar recreación de componentes

  @Output() cumpleValidacion: boolean = true;

  public sidePanel: any;
  public sidePanelInstance: any;

  @Input() public workFlowItem: any = null;

  // false = color blanco, true = color = gris
  panelColor = true;
  @Input() form: FormGroup;

  @Input() SearcheableConfigs: Array<any> = [];
  constructor(

    public utility: Utilities,
    public baseService: BaseServiceService,
    public componentFactoryResolver: ComponentFactoryResolver,
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public helperImages: HelperImages,
    public cdr: ChangeDetectorRef
) {

    super(utility, baseService, sanitizer, helperImages);

  }

  SetSidePanel() {
    //debugger;
    if (!this.sidePanel) {
      this.sidePanel = document.querySelector("#" + this.subControl.Name);
      if (!this.sidePanel) {
        console.warn(`No se encontró el elemento SidePanel con ID: ${this.subControl.Name}`);
      }
    }
  }
  //* FUNCIONES ANGULAR

  ngOnDestroy() {
    // Limpiar correctamente la instancia de Fabric
    if (this.sidePanelInstance) {
      try {
        if (typeof this.sidePanelInstance.dispose === 'function') {
          this.sidePanelInstance.dispose();
        }
      } catch (error) {
        console.warn('Error disposing Fabric Panel in ngOnDestroy:', error);
      }
      this.sidePanelInstance = null;
    }

    // Limpiar referencias DOM
    this.sidePanel = null;
    this.sidePanelKey = '';

    // Limpiar observables para evitar errores de ObjectUnsubscribedError
    try {
      if (this.parentCallRefresh && !this.parentCallRefresh.closed) {
        this.parentCallRefresh.complete();
      }
      if (this.parentClearCall && !this.parentClearCall.closed) {
        this.parentClearCall.complete();
      }
    } catch (error) {
      console.warn('Error al completar observables en ngOnDestroy:', error);
    }
  }
  ngAfterViewInit() {
    if (this.subControl && this.subControl.ControlType === 'SidePanel') {
      this.name = this.subControl.Name;
      if (this.subControl.OpenaPanel) {
        // Delay para asegurar que el DOM esté listo
        setTimeout(() => {
          this.OpenSidePanel();
        }, 100);
      } else {
        this.SetSidePanel();
      }
      if (this.onInitialized && this.onInitialized.observers && this.onInitialized.observers.length) {
        setTimeout(() => {
          this.onInitialized.emit(this);
        }, 1000);
      }
    }

    if (this.subControl && this.subControl.ControlType === 'AdminPermisosPalabrasClave') {
      this.name = this.subControl.Name;
      // Delay para asegurar que el elemento esté en el DOM
      setTimeout(() => {
        const PivotElement = document.querySelector("#" + this.subControl.Name);
        if (PivotElement && fabric && fabric['Pivot']) {
          try {
            new fabric['Pivot'](PivotElement);
          } catch (error) {
            console.warn('Error inicializando Fabric Pivot:', error);
          }
        }
      }, 100);
    }

    if (this.subControl && this.subControl.ControlType === 'PermisosTiposDocMetadatos') {
      //debugger;
      this.name = this.subControl.Name;
      // Delay para asegurar que el elemento esté en el DOM
      setTimeout(() => {
        const PivotElement = document.querySelector("#" + this.subControl.Name);
        if (PivotElement && fabric && fabric['Pivot']) {
          try {
            new fabric['Pivot'](PivotElement);
          } catch (error) {
            console.warn('Error inicializando Fabric Pivot:', error);
          }
        }
      }, 500);
    }

    if (this.subControl && this.subControl.ViewLog) {
      this.LogTimeView();
    }
  }

  ngOnInit() {

    if (this.subControl) {
      if (this.subControl.Type == "WorkFlowTask") {
        if (this.isModelContainer && !this.modelo.WorkFlowTaskModel) {
          this.modelo.WorkFlowTaskModel = {};
        }
      }

      if (!this.subControl.ModelContainer)
        this.subControl.ModelContainer = "modelo";
      /*  if (this.subControl && this.subControl.ControlType === 'Pagina') {

         let pagina = this.utility.FindPage(StaticData.Usuario.Paginas, 'IdPagina', this.subControl.IdPagina) //this.utility.FindAndConfigPage(this.subControl .IdPagina);
         if (pagina) {
           this.subControl.Controls = pagina.ConfigPage.Controls;
         }
         else {
           this.utility.logger.LogWarningText('No se encontro la pagina: ' + this.subControl.Name + ', Con Id:' + this.subControl.IdPagina + ' Para DynamicControlsComponent');
         }
       } */
      if (this.subControl.ControlType == 'DynamicComponentViewer') {
        setTimeout(() => {
          this.LoadDynamicComponent();
        }, 200);
      }

      if (this.subControl && (this.subControl.ControlType === 'FormContainer' ||
        this.subControl.ControlType === 'FormGroup')) {
        if (this.isModelContainer && this.subControl.ModelContainer && !this.modelo[this.subControl.ModelContainer]) {
          this.modelo[this.subControl.ModelContainer] = {};
        }
        if (this.onInitialized && this.onInitialized.observers && this.onInitialized.observers.length) {
          setTimeout(() => {
            this.onInitialized.emit(this);
          }, 1000);
        }
      }
      if (this.subControl.Searcheable) {
        this.SetOp("Equal");
      }

    }
    this.OnInitInternal();

  }

  //* END FUNCIONES ANGULAR

  //* FUNCIONES PERSONALIZADAS

  // Función para validar que los observables estén activos antes de usarlos
  private isObservableActive(observable: Subject<any>): boolean {
    return observable && !observable.closed && !observable.isStopped;
  }

  // Función para recrear observables si están cerrados
  private ensureObservablesActive(): void {
    if (!this.isObservableActive(this.parentCallRefresh)) {
      console.warn('parentCallRefresh estaba cerrado, recreando...');
      this.parentCallRefresh = new Subject<any>();
    }
    if (!this.isObservableActive(this.parentClearCall)) {
      console.warn('parentClearCall estaba cerrado, recreando...');
      this.parentClearCall = new Subject<any>();
    }
  }

  changeSwap(event) {

    if (this.Pagina.ConfigPage.Swap) {
      console.log("aca un swap");
      if (!(<any>$(event.target)).hasClass("active") && ((<any>$(event.target)).hasClass("swap__form") || (<any>$(event.target)).hasClass("swap__grid"))) {
        (<any>$('.swap__grid')).toggleClass('active');
        (<any>$('.swap__form')).toggleClass('active');
      }
    }

  }

  public OnValidate(event) {

    this.cumpleValidacion = event;

  }

  public OpenSidePanel() {
    //debugger;
    // Asegurar que los observables estén activos antes de usar
    this.ensureObservablesActive();

    // Generar una nueva clave única para forzar la recreación de componentes
    this.sidePanelKey = 'sidePanel_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    this.showSidePanel = true;

    // Forzar detección de cambios múltiple para asegurar que el DOM se actualice completamente
    this.cdr.detectChanges();

    // Usar setTimeout para asegurar que el DOM esté completamente renderizado
    setTimeout(() => {
      this.SetSidePanel();
      if (this.sidePanel && !this.sidePanelInstance) {
        try {
          this.sidePanelInstance = new fabric["Panel"](this.sidePanel);
          // Agregar listener para detectar cuando el panel se cierra desde fuera
          this.setupPanelCloseListener();
        } catch (error) {
          console.error('Error inicializando Fabric Panel:', error);
          // Reintentar después de un pequeño delay
          setTimeout(() => {
            this.SetSidePanel();
            if (this.sidePanel) {
              try {
                this.sidePanelInstance = new fabric["Panel"](this.sidePanel);
                // Agregar listener para detectar cuando el panel se cierra desde fuera
                this.setupPanelCloseListener();
              } catch (retryError) {
                console.error('Error en segundo intento de inicialización Fabric Panel:', retryError);
              }
            }
          }, 200);
        }
      }

      // Emitir evento para notificar que el panel se ha abierto
      if (this.isObservableActive(this.parentCallRefresh)) {
        this.parentCallRefresh.next({ action: 'sidePanelOpened', key: this.sidePanelKey });
      }
    }, 100);
  }

  public CloseSidePanel() {
    this.performPanelCleanup();
  }

  // Método privado que contiene toda la lógica de limpieza del panel
  private performPanelCleanup() {
    // Emitir evento antes de cerrar para que los componentes limpien sus recursos
    //if (this.isObservableActive(this.parentClearCall)) {
    //  this.parentClearCall.next({ action: 'sidePanelClosing', key: this.sidePanelKey });
    //}

    // Limpiar la instancia de Fabric antes de ocultar el panel
    if (this.sidePanelInstance) {
      try {
        // Si Fabric tiene un método dispose, usarlo
        if (typeof this.sidePanelInstance.dispose === 'function') {
          this.sidePanelInstance.dispose();
        }
      } catch (error) {
        console.warn('Error disposing Fabric Panel:', error);
      }
      this.sidePanelInstance = null;
    }

    this.showSidePanel = false;
    this.sidePanel = null;
    this.sidePanelKey = ''; // Limpiar la clave
    this.cdr.detectChanges();

    // Timeout adicional para asegurar limpieza completa
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  // Método para configurar el listener que detecta cuando el panel se cierra desde fuera
  private setupPanelCloseListener() {
    if (this.sidePanel) {
      // Usar MutationObserver para detectar cambios en las clases CSS del panel
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target as HTMLElement;
            // Si el panel ya no tiene la clase 'is-open' significa que se cerró
            if (!target.classList.contains('is-open') && this.showSidePanel) {
              //console.log('Panel cerrado desde fuera detectado');
              this.performPanelCleanup();
              observer.disconnect(); // Desconectar el observer
            }
          }
        });
      });

      // Observar cambios en los atributos del panel
      observer.observe(this.sidePanel, {
        attributes: true,
        attributeFilter: ['class']
      });

      // También detectar clics en el overlay (backdrop)
      setTimeout(() => {
        const overlay = document.querySelector('.ms-Overlay');
        if (overlay) {
          const overlayClickHandler = (event) => {
            if (event.target === overlay && this.showSidePanel) {
              //console.log('Panel cerrado por click en overlay detectado');
              this.performPanelCleanup();
              overlay.removeEventListener('click', overlayClickHandler);
            }
          };
          overlay.addEventListener('click', overlayClickHandler);
        }
      }, 100);
    }
  }

  //! NO HACE NADA
  public OnInitInternal() { }

  public InternoonLimpiarConfirm() {

    alert('Sesundoa');
    this.onLimpiarConfirm.emit();

  }

  //! NO HACE NADA
  public OnSelectedComboBox(item, controlName, config) { }

  public get ComboxConfig(): any {

    if (this.comboxConfigs)
      return this.comboxConfigs['Config' + this.subControl.Name];
    else
      return null;

  }

  //! NO HACE NADA
  public AdicionarControlFormulario() {
    /*  if(this.frm && this.frm.form && this.subControl && this.utility.EsControlFormulario(this.subControl)){

       let ctrl =new FormControl('');
       this.frm.form.addControl(this.subControl.Name,ctrl);
     //this.frm.form.controls
     } */
    // let fieldsCtrls = {};
    // for (let f of this.fields) {
    //   if (f.type != 'checkbox') {
    //     fieldsCtrls[f.name] = new FormControl(f.value || '', Validators.required)
    //   } else {
    //     let opts = {};
    //     for (let opt of f.options) {
    //       opts[opt.key] = new FormControl(opt.value);
    //     }
    //     fieldsCtrls[f.name] = new FormGroup(opts)
    //   }
    // }
    // this.frm.form = new FormGroup(fieldsCtrls);
  }

  minimizeMode: boolean = true;
  _colSpan: string;

  resize() {

    if (this.minimizeMode) {
      this._colSpan = this.subControl.ColSpan;
      this.subControl.ColSpan = 12;

    }
    else
      this.subControl.ColSpan = this._colSpan;

    this.minimizeMode = !this.minimizeMode;

  }

  get ColSpan(): string {

    /*    if (this.subControlParent && (this.subControlParent.ControlType == 'DragContainerBox' ||
         this.subControlParent.ControlType == 'DragPanel')) {
         return '12';
       } */
    if (this.subControlParent || this.isFirst) {
      return '12';
    }
    return this.subControl.ColSpan;

  }

  itemDropped(event: CdkDragDrop<any[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(this.subControl.Controls, event.previousIndex, event.currentIndex);
    } else { }

  }

  LoadDynamicComponent() {

    if (this.subControl.Activo != true)
      return;
    let _bodyComponent: any;
    var factories = Array.from(this.componentFactoryResolver['_factories'].keys());
    _bodyComponent = factories.find((x: any) => x.name === this.subControl.ComponentName);

    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory<any>(_bodyComponent)
      .create(this.injector);
    const component: any = componentRef.instance;

    if (component) {
      component.parentCallRefresh = this.parentCallRefresh;
      component.parentCallRefresh = this.parentCallRefresh;
      component.parentClearCall = this.parentClearCall;
      component.componentsContainer = this.componentsContainer;
      component.modelo = this.modelo;
      component.onActionEventEmitter = this.onActionEventEmitter;
      component.config = this.subControl;
      //COmentareada la linea por marlon Granda 29/10/2020
      // component.name = this.subControl.Name;
      component.isDynamic;
      //component.onInitialized = this.onInitialized;
      //component.valueChange.subscribe(val => this.selectedValue = val);
      this.AddChild(component);
    }

    this.DynamicComponentViewer.insert(componentRef.hostView);

  }

  public AddChild(component) {

    if (component) {
      if (!this.childComponents)
        this.childComponents = [];
      let _component = new List(this.childComponents).FirstOrDefault(x => { return x.name == component.name });
      if (!_component) {
        this.onInitialized.emit(component);
      }
      //this.childComponents.push(component);
    }

  }

  //* END FUNCIONES PERSONALIZADAS

  // Función para mejorar el rendimiento de ngFor y evitar problemas de reinicialización
  trackByFn(index: number, item: any): any {
    // Usar la clave del panel más el índice y nombre del control para crear una clave única
    const baseKey = item.Name || item.Id || index;
    return this.sidePanelKey ? `${this.sidePanelKey}_${baseKey}_${index}` : baseKey;
  }

  searcheableConfig: any;

  IsLogicalOp(op) {

    if (this.SearcheableConfigs && this.SearcheableConfigs.length > 0) {
      this.searcheableConfig = this.SearcheableConfigs.find(x => x.Name == this.subControl.Name);
      if (this.searcheableConfig)
        return (this.searcheableConfig.LogicOp == op);
      else
        return null;
    }
    else
      return null;
  }


  SetLogicalOp(op) {

    if (this.SearcheableConfigs.length > 0) {
      this.searcheableConfig = this.SearcheableConfigs.find(x => x.Name == this.subControl.Name);
      if (this.searcheableConfig)
        this.searcheableConfig.LogicOp = op;
      else
        this.SearcheableConfigs.push({
          Name: this.subControl.Name, Label: this.subControl.Label, Op: "Equal",
          LogicOp: op, SearcheableFieldName: this.subControl.SearcheableFieldName,
          DataType: this.subControl.DataType, ControlType: this.subControl.ControlType
        })

    }
    else
      this.SearcheableConfigs.push({
        Name: this.subControl.Name, Label: this.subControl.Label, Op: "Equal",
        LogicOp: op, SearcheableFieldName: this.subControl.SearcheableFieldName,
        DataType: this.subControl.DataType, ControlType: this.subControl.ControlType
      });

    this.onActionEventEmitter.emit({ Name: this.subControl.Name, Action: 'SetLogicalOp' });
  }
  IsOp(op) {

    if (this.SearcheableConfigs && this.SearcheableConfigs.length > 0) {
      this.searcheableConfig = this.SearcheableConfigs.find(x => x.Name == this.subControl.Name);
      if (this.searcheableConfig)
        return (this.searcheableConfig.Op == op);
      else
        return null;
    }
    else
      return null;
  }


  SetOp(op) {

    if (this.SearcheableConfigs.length > 0) {
      this.searcheableConfig = this.SearcheableConfigs.find(x => x.Name == this.subControl.Name);
      if (this.searcheableConfig)
        this.searcheableConfig.Op = op;
      else {
        this.SearcheableConfigs.push({
          Name: this.subControl.Name, Label: this.subControl.Label, Op: op, LogicOp: "And", SearcheableFieldName: this.subControl.SearcheableFieldName,
          DataType: this.subControl.DataType, ControlType: this.subControl.ControlType
        })
      }

    }
    else
      this.SearcheableConfigs.push({
        Name: this.subControl.Name, Label: this.subControl.Label, Op: op, LogicOp: "And",
        SearcheableFieldName: this.subControl.SearcheableFieldName,
        DataType: this.subControl.DataType, ControlType: this.subControl.ControlType
      });

    this.onActionEventEmitter.emit({ Name: this.subControl.Name, Action: 'SetOp' });
  }



  labelTime: any = "";
  public LogTimeView() {
    if (StaticData.StopWatchView) {
      StaticData.StopWatchView.stop();
      const time = StaticData.StopWatchView.getTime();
      const timeFormat = this.utility.FormatStopWatch(time);
      console.info("TIEMPO PAGINA S1: " + time);
      console.info("TIEMPO PAGINA S2: " + timeFormat);
      this.labelTime = "TIEMPO PAGINA S1: " + time + "\n" + "TIEMPO PAGINA S2: " + timeFormat + "\n";
    }
    var endProcess = new Date().getTime();
    const time = endProcess - StaticData.StartProcessView;
    const timeFormat = this.utility.FormatStopWatch(time);
    console.info("TIEMPO PAGINA1: " + time);
    console.info("TIEMPO PAGINA2: " + timeFormat);

    this.labelTime += "TIEMPO PAGINA1: " + time + "\n" + "TIEMPO PAGINA2: " + timeFormat + "\n";
  }

}
